import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { HOME_SERVICES } from '../../data/content';
import { useLanguage } from '../../i18n/LanguageContext';
export function ServicesGrid() {
  const {
    lang,
    t
  } = useLanguage();
  return <section className="w-full bg-mist py-24 lg:py-32" aria-labelledby="services-heading" data-id="element-147" data-mp="3neh9m0rqcis1">
      <div className="mx-auto max-w-container px-6" data-id="element-148" data-mp="nyuc1nbv8zhj">
        <div id="services-heading" data-id="element-149" data-mp="k0mvashejy6c">
          <SectionHeading eyebrow={t.services.eyebrow} title={t.services.title} description={t.services.description} align="center" data-id="element-150" data-mp="jxh334dh8g6e" />
        </div>

        <ul className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-151" data-mp="a3rws9l4pxs2">
          {HOME_SERVICES.map((service, i) => <Reveal as="li" key={service.copy.en.title} delay={i * 0.05} data-id="element-152" data-mp="2urwecp84vmj7" data-mpi={i}>
              <Link to="/services" className="group flex h-full flex-col rounded-2xl border border-navy-100 bg-white p-7 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-lift" data-id="element-153" data-mp="2utzg26inf43r">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-navy-50 text-navy transition-colors duration-300 group-hover:bg-navy group-hover:text-gold" data-id="element-154" data-mp="1qv0ppw5e7xkc">
                  <service.Icon className="h-5 w-5" aria-hidden="true" data-id="element-155" data-mp="1h4o6q8d88cgb" />
                </span>
                <h3 className="mt-6 font-display text-xl font-semibold text-navy" data-id="element-156" data-mp="1lxhc8ygirotg">
                  {service.copy[lang].title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-charcoal-light" data-id="element-157" data-mp="1837vxzii28bk">
                  {service.copy[lang].description}
                </p>
                <span className="mt-6 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-gold-dark" data-id="element-158" data-mp="y868r97sbgbm">
                  {t.services.learnMore}
                  <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-159" data-mp="k1l01jbol6m8" />
                </span>
              </Link>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}